<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_ix"></a><span class="bold">Abbreviations</span></h2>
<table>
<tbody><tr>
<td>
<p class="ttext"><span class="bold">AA</span></p>
</td>
<td>
<p class="ttext">Anti-aircraft</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ACASI</span></p>
</td>
<td>
<p class="ttext">Assistant Chief of the Air Staff (Intelligence)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ACIGS</span></p>
</td>
<td>
<p class="ttext">Assistant Chief of Imperial General Staff</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ADA</span></p>
</td>
<td>
<p class="ttext">Assistant Director, ‘A’ Branch (MI5)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ADC</span></p>
</td>
<td>
<p class="ttext">Aide-de-camp</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ADNI</span></p>
</td>
<td>
<p class="ttext">Assistant Director Naval Intelligence</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">AEG</span></p>
</td>
<td>
<p class="ttext">Allgemeine Elektricitäts-Gesellschaft AG (English: “General electricity company”)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">AFDC</span></p>
</td>
<td>
<p class="ttext">Air Force Department Constabulary; Air Force Development Centre</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">AGF</span></p>
</td>
<td>
<p class="ttext">Anglo-German Fellowship</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">AOA</span></p>
</td>
<td>
<p class="ttext">Air Officer i/c Administration (RAF)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">AOC</span></p>
</td>
<td>
<p class="ttext">Air Officer Commanding (RAF)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">APM</span></p>
</td>
<td>
<p class="ttext">Assistant Provost Marshal</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ARP</span></p>
</td>
<td>
<p class="ttext">Air Raid Precautions</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">A/T</span></p>
</td>
<td>
<p class="ttext">Anti-tank</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ATS</span></p>
</td>
<td>
<p class="ttext">Auxiliary Transport Service</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BAOR</span></p>
</td>
<td>
<p class="ttext">British Army of the Rhine</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BOAC</span></p>
</td>
<td>
<p class="ttext">British Overseas Airways Corporation</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BRCS</span></p>
</td>
<td>
<p class="ttext">British Red Cross Society</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BSA</span></p>
</td>
<td>
<p class="ttext">Birmingham Small Arms Company, Enfield</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BSS</span></p>
</td>
<td>
<p class="ttext">Bayswater Security Section (SOE)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">BUF</span></p>
</td>
<td>
<p class="ttext">British Union of Fascists (later shortened to British Union)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CCG (BE)</span></p>
</td>
<td>
<p class="ttext">Control Commission Germany (British Element) (post-war)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CDRD</span></p>
</td>
<td>
<p class="ttext">Chemical Defence Research Department, Porton Down</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">C-in-C</span></p>
</td>
<td>
<p class="ttext">Commander-in-Chief</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CIA</span></p>
</td>
<td>
<p class="ttext">Chief Inspector of Arms</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CID</span></p>
</td>
<td>
<p class="ttext">Criminal Investigation Department</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CIGS</span></p>
</td>
<td>
<p class="ttext">Chief of Imperial General Staff (British Army)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CISA</span></p>
</td>
<td>
<p class="ttext">Chief Inspector of Small Arms</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CIU</span></p>
</td>
<td>
<p class="ttext">Central Interpretation Unit, RAF Medmenham</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CO</span></p>
</td>
<td>
<p class="ttext">Commanding Officer</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CPR</span></p>
</td>
<td>
<p class="ttext">Combined Planning Research Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CRO</span></p>
</td>
<td>
<p class="ttext">Criminal Records Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">CSWBL</span></p>
</td>
<td>
<p class="ttext">Central Security War Black List</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><a id="page_x"></a><span class="bold">CX</span></p>
</td>
<td>
<p class="ttext">SIS reports</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DAF</span></p>
</td>
<td>
<p class="ttext">Deutsche Arbeitsfront (German Labour Front)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DofI (S)</span></p>
</td>
<td>
<p class="ttext">Director of Intelligence (Security), Air Ministry</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DDI (S)</span></p>
</td>
<td>
<p class="ttext">Deputy Director of Intelligence (Security), Air Ministry</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DDW</span></p>
</td>
<td>
<p class="ttext">Deputy Director of Weapons (War Office)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DMI</span></p>
</td>
<td>
<p class="ttext">Director(ate) of Military Intelligence</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DNI</span></p>
</td>
<td>
<p class="ttext">Director(ate) of Naval Intelligence</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DNO</span></p>
</td>
<td>
<p class="ttext">Director(ate) of Naval Ordnance</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DOT</span></p>
</td>
<td>
<p class="ttext">Department of Overseas Trade</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">DSR</span></p>
</td>
<td>
<p class="ttext">Director(ate) of Scientific Research</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">FBI</span></p>
</td>
<td>
<p class="ttext">Federal Bureau of Investigation (USA)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">FPS</span></p>
</td>
<td>
<p class="ttext">Future (Operational) Planning Section (also FOPS)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">GLU</span></p>
</td>
<td>
<p class="ttext">General Look-Up</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">GOC-in-C</span></p>
</td>
<td>
<p class="ttext">General Officer Commanding-in-Chief</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">GPO</span></p>
</td>
<td>
<p class="ttext">General Post Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">GRU</span></p>
</td>
<td>
<p class="ttext">Soviet/Russian military intelligence</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">GSO2</span></p>
</td>
<td>
<p class="ttext">General Staff Officer 2 (Major)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">HDE</span></p>
</td>
<td>
<p class="ttext">Home Defence Executive</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">HMG</span></p>
</td>
<td>
<p class="ttext">His Majesty’s Government</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">HO</span></p>
</td>
<td>
<p class="ttext">Home Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">HOW</span></p>
</td>
<td>
<p class="ttext">Home Office Warrant</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IARHC</span></p>
</td>
<td>
<p class="ttext">Inter-Allied Rhineland High Commission</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IB</span></p>
</td>
<td>
<p class="ttext">Investigation Branch (GPO); Intelligence Branch</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IO</span></p>
</td>
<td>
<p class="ttext">Immigration Officer</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IP</span></p>
</td>
<td>
<p class="ttext">International Police (Portugal)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IPI</span></p>
</td>
<td>
<p class="ttext">Indian Political Intelligence</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">IRBd</span></p>
</td>
<td>
<p class="ttext">Information &amp; Records Branch, Imperial Censorship</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ISOS</span></p>
</td>
<td>
<p class="ttext">Intelligence Service Oliver Strachey/Illicit Services Oliver Strachey (Abwehr hand cypher intercepts)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ISRB</span></p>
</td>
<td>
<p class="ttext">Inter-Services Research Bureau (cover name for SOE)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">ISSB</span></p>
</td>
<td>
<p class="ttext">Inter-Services Security Board</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">JIC</span></p>
</td>
<td>
<p class="ttext">Joint Intelligence Committee</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">KO</span></p>
</td>
<td>
<p class="ttext">Kriegsorganisation (War Organisation – Abwehr in Allied and neutral countries)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">LCS</span></p>
</td>
<td>
<p class="ttext">London Controlling Section</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">LU</span></p>
</td>
<td>
<p class="ttext">Look-up</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MAP</span></p>
</td>
<td>
<p class="ttext">Ministry of Aircraft Production</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MEW</span></p>
</td>
<td>
<p class="ttext">Ministry of Economic Warfare</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MGB</span></p>
</td>
<td>
<p class="ttext">Motor Gun Boat</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MGO</span></p>
</td>
<td>
<p class="ttext">Master-General of the Ordnance</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MI1c</span></p>
</td>
<td>
<p class="ttext">Former designation for MI6</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MI5</span></p>
</td>
<td>
<p class="ttext">Security Service</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MI6</span></p>
</td>
<td>
<p class="ttext"><em class="italic">q.v</em>. SIS</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MI10</span></p>
</td>
<td>
<p class="ttext">Directorate of War Office responsible for weapons and technical analysis</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MI11</span></p>
</td>
<td>
<p class="ttext">Directorate of War Office responsible for field security</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><a id="page_xi"></a><span class="bold">MI(R)</span></p>
</td>
<td>
<p class="ttext">Sabotage and guerilla operations (forerunner of SOE)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MOL</span></p>
</td>
<td>
<p class="ttext">Ministry of Labour</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MOS</span></p>
</td>
<td>
<p class="ttext">Ministry of Supply</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MOT</span></p>
</td>
<td>
<p class="ttext">Ministry of Overseas Trade</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MS</span></p>
</td>
<td>
<p class="ttext">Military Secretary’s Office (War Office)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MTB</span></p>
</td>
<td>
<p class="ttext">Motor Torpedo Boat</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">MTC</span></p>
</td>
<td>
<p class="ttext">Motor Transport Corps</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">NID</span></p>
</td>
<td>
<p class="ttext">Naval Intelligence Division</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">NSDAP</span></p>
</td>
<td>
<p class="ttext">Nationalsozialistische Deutsche Arbeiterpartie (National Socialist German Workers’ Party – Nazi Party)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">OGPU</span></p>
</td>
<td>
<p class="ttext">Soviet intelligence (1922-34)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">OKW</span></p>
</td>
<td>
<p class="ttext">Oberkommando der Wehrmacht (High Command of the German Army)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">OMGUS</span></p>
</td>
<td>
<p class="ttext">Office of Military Government United States</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">PCO</span></p>
</td>
<td>
<p class="ttext">Passport Control Officer</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">PID</span></p>
</td>
<td>
<p class="ttext">Political Intelligence Department (Foreign Office)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">PUS</span></p>
</td>
<td>
<p class="ttext">Permanent Under-Secretary</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAC</span></p>
</td>
<td>
<p class="ttext">Royal Automobile Club</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAD</span></p>
</td>
<td>
<p class="ttext">Reichsleitung des Arbeitsdienstes (Management of the Labour Service)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAE</span></p>
</td>
<td>
<p class="ttext">Royal Aircraft Establishment</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAF</span></p>
</td>
<td>
<p class="ttext">Royal Air Force</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAFVR</span></p>
</td>
<td>
<p class="ttext">Royal Air Force Volunteer Reserve</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAMC</span></p>
</td>
<td>
<p class="ttext">Royal Army Medical Corps</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RAOC</span></p>
</td>
<td>
<p class="ttext">Royal Army Ordnance Corps</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RCMP</span></p>
</td>
<td>
<p class="ttext">Royal Canadian Mounted Police</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RE</span></p>
</td>
<td>
<p class="ttext">Royal Engineers</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">REME</span></p>
</td>
<td>
<p class="ttext">Royal Electrical &amp; Mechanical Engineers</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RMO</span></p>
</td>
<td>
<p class="ttext">Royal Marine Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RNVR</span></p>
</td>
<td>
<p class="ttext">Royal Navy Volunteer Reserve</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">Room 055</span></p>
</td>
<td>
<p class="ttext">War Office liaison with MI5</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RSHA</span></p>
</td>
<td>
<p class="ttext">Reichssicherheitshauptsamt (Reich Main Security Office)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RSLO</span></p>
</td>
<td>
<p class="ttext">Regional Security Liaison Officer (MI5)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">RSS</span></p>
</td>
<td>
<p class="ttext">Radio Security Service, MI8c (MI6)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SD</span></p>
</td>
<td>
<p class="ttext">Sicherheitsdienst (SS intelligence)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SIME</span></p>
</td>
<td>
<p class="ttext">Security Intelligence Middle East</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SIS</span></p>
</td>
<td>
<p class="ttext">Secret Intelligence Service <em class="italic">q.v</em>. MI6</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SO2</span></p>
</td>
<td>
<p class="ttext">Forerunner of SOE</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SOE</span></p>
</td>
<td>
<p class="ttext">Special Operations Executive</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">SOI</span></p>
</td>
<td>
<p class="ttext">Staff Officer Intelligence (RN)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">STD</span></p>
</td>
<td>
<p class="ttext">Soviet Trade Delegation</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">VAD</span></p>
</td>
<td>
<p class="ttext">Voluntary Aid Detachment</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">VCIGS</span></p>
</td>
<td>
<p class="ttext">Vice Chief of the Imperial General Staff</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">WAAF</span></p>
</td>
<td>
<p class="ttext">Women’s Auxiliary Air Force</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">WO</span></p>
</td>
<td>
<p class="ttext">War Office</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">XX</span></p>
</td>
<td>
<p class="ttext">Double Cross Committee</p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Abbreviations.vue?11d57118